import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../navbar/Navbar';

const FullWidthLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-950 transition-colors duration-300">
      <Navbar />
      <main className="pt-32">
        {/* 🟢 CONTENIDO PRINCIPAL: Ahora ocupa todo el ancho del contenedor */}
        <div className="container mx-auto px-4 py-8 text-gray-900 dark:text-gray-100">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default FullWidthLayout;
